import { UserMergeRequestListFilterInput } from 'src/graphql/generated/graphql';
import { UserMergeRequestsTable } from './table';
import { useTable } from 'src/hooks/use-table';
import { useUserMergeRequests } from 'src/hooks/query/user-merge-requests/use-user-merge-requests';
import { UserMergeRequestListItem } from './types';

const PAGINATION_LIMIT = 10;

type UserMergeRequestsListProps = {
  filter: UserMergeRequestListFilterInput;
};

export const UserMergeRequestsList = ({
  filter,
}: UserMergeRequestsListProps) => {
  const { page, setPage } = useTable();

  const { loading, data, totalCount } = useUserMergeRequests({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  return (
    <UserMergeRequestsTable
      data={data as UserMergeRequestListItem[]}
      className="mt-4"
      hiddenColumns={['profileActions']}
      loading={loading}
      options={{
        page,
        count: totalCount,
        sort: true,
        rowsPerPage: PAGINATION_LIMIT,
        onChangePage: setPage,
        enableNestedDataAccess: '.',
      }}
    />
  );
};
